
import { useEffect } from "react";

import classes from './Chatbot.module.scss';

const Chatbot = () => {
  useEffect(() => {
    const handleMessage = (event) => {
      const chatIframe = document.getElementById("openassistantgpt-chatbot-iframe");
      const buttonIframe = document.getElementById("openassistantgpt-chatbot-button-iframe");

      if (event.data === "openChat") {
        if (chatIframe && buttonIframe) {
          chatIframe.contentWindow?.postMessage("openChat", "*");
          buttonIframe.contentWindow?.postMessage("openChat", "*");
          chatIframe.style.pointerEvents = "auto";
          chatIframe.style.display = "block";

          if (window.innerWidth < 640) {
            chatIframe.style.position = "fixed";
            chatIframe.style.width = "100%";
            chatIframe.style.height = "100%";
            chatIframe.style.top = "0";
            chatIframe.style.left = "0";
            chatIframe.style.zIndex = "9999";
          } else {
            chatIframe.style.position = "fixed";
            chatIframe.style.width = "480px";
            chatIframe.style.height = "65vh";
            chatIframe.style.bottom = "0";
            chatIframe.style.right = "0";
          }
        }
      } else if (event.data === "closeChat" && chatIframe && buttonIframe) {
        chatIframe.style.display = "none";
        chatIframe.style.pointerEvents = "none";
        chatIframe.contentWindow?.postMessage("closeChat", "*");
        buttonIframe.contentWindow?.postMessage("closeChat", "*");
      }
    };

    window.addEventListener("message", handleMessage);
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  return (
    <>
      {/* Button iframe */}
      <iframe
        src="https://www.openassistantgpt.io/embed/cm915j0s50007j5b1kwytftk8/button?chatbox=false"
        className={classes['chat-button']}       
        id="openassistantgpt-chatbot-button-iframe"
      ></iframe>

      {/* Chatbot iframe */}
      <iframe
        src="https://www.openassistantgpt.io/embed/cm915j0s50007j5b1kwytftk8/window?chatbox=false&withExitX=true"
        style={{
          zIndex: 1000,
          marginRight: "6px",
          marginBottom: "98px",
          display: "none",
          position: "fixed",
          right: 0,
          bottom: 0,
          pointerEvents: "none",
          overflow: "hidden",
          height: "65vh",
          border: "2px solid #e2e8f0",
          borderRadius: "0.375rem",
          boxShadow:
            "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
          width: "480px",
        }}
        allow="clipboard-read; clipboard-write"
        allowFullScreen
        id="openassistantgpt-chatbot-iframe"
      ></iframe>
    </>
  );
};

export default Chatbot;
